import React, { PureComponent } from 'react';
import Upcoming from '../../VisitCard/Upcoming/Upcoming';
import ConnectedPast from '../../VisitCard/ConnectedPast';
import { BookingStatus } from '../../../../../constants/index';

type OwnProps = {
  tile: any;
  tileIndex: number;
  userProfile: any;
  locations: any;
  pastBookings?: any[];
  upcomingBookings?: any[];
  isTelemed?: boolean;
};

type Props = OwnProps & typeof Visit.defaultProps;

class Visit extends PureComponent<Props> {
  static defaultProps = {
    isTelemed: false,
  };

  getLocation = () => {
    const { locations, isTelemed } = this.props;

    if (isTelemed && locations.telemed) {
      return locations.telemed;
    }

    if (!isTelemed && locations.recent) {
      return locations.recent;
    }

    return null;
  };

  render = () => {
    const location = this.getLocation();

    if (!location) {
      return null;
    }

    const {
      locations,
      tile: { booking },
    } = this.props;

    if (!locations.user[booking.location_id]) {
      // There's some cases (mainly in test data) where you've booked a location that isn't
      // bookable. We currently filter on the 'is_bookable' flag when fetching locations,
      // which causes the below logic to crash when components are expecting a location.
      // Curiously, if a partner decided to churn, people looking at this screen would no longer
      // be able to see evidence of their appointment.
      return null;
    }

    if (
      BookingStatus.PRE_VISIT.includes(booking.status) ||
      BookingStatus.IN_VISIT.includes(booking.status)
    ) {
      return (
        <Upcoming
          appointmentDate={booking.original_appointment_date}
          booking={booking}
          bookingHasInsuranceInfo={booking.has_insurance_info}
          bookingInsurerType={booking.insurer_type}
          bookingTimeZone={booking.time_zone}
          location={locations.user[booking.location_id]}
          userProfileId={booking.user_profile_id}
        />
      );
    }

    return (
      <ConnectedPast
        booking={booking}
        location={locations.user[booking.location_id]}
        userProfileId={booking.user_profile_id}
      />
    );
  };
}

export default Visit;
